import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import Create from "views/TerminalFee/Create";
import Delete from "views/TerminalFee/Delete";
import Edit from "views/TerminalFee/Edit";
import List from "views/TerminalFee/List";

import { token } from "functions/Helper";

const terminalFee = () => {
  let views = [];

  if (
    token["booking.terminal_fees.read"] === "allowed" ||
    token.is_admin === "True"
  )
    views.push({
      path: "/TerminalFees/List",
      name: "Terminal Fees",
      icon: LocalShippingIcon,
      component: List,
      layout: "/admin"
    });

  return views;
};

const terminalFeeHidden = () => {
  let views = [];

  if (
    token["booking.terminal_fees.write"] === "allowed" ||
    token.is_admin === "True"
  )
    views = views.concat([
      {
        path: "/TerminalFees/Create",
        name: "Create Terminal Fee",
        component: Create,
        layout: "/admin"
      },
      {
        path: "/TerminalFees/Edit",
        name: "Edit Terminal Fee",
        component: Edit,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/TerminalFees/Delete",
        name: "Delete Terminal Fee",
        component: Delete,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Terminal Fee Hidden",
        state: "terminalFeeHidden",
        hideInSidebar: true,
        views: views
      }
    ];

  return [];
};

export { terminalFee, terminalFeeHidden };
